var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBancodelpacifico = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0076B6;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.5,500h-361C31.1,500,0,468.9,0,430.5v-361C0,31.1,31.1,0,69.5,0h361C468.9,0,500,31.1,500,69.5v361 C500,468.9,468.9,500,430.5,500z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.9,89.3h169.5c0,0,70.9,7.1,77.4,73.4v173.6H195.2c0,0-60.2-3.5-72.4-76.4V89.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.2,201.6v-33.9c0,0,6.6-42.5,47.6-40.5c0,0,40-3,48.1,45c0,0,4.6,23.3-18.2,40.5c0,0,18.5,12.1,18.6,38.5 c0,0-4.6,44.5-48,46.1c0,0-21.7,2.5-37.9-17.7c0,0-15.2,20.4-36.9,17.8c0,0-44,1.9-48.1-49.2c0,0,0-39.5,39.5-46.1L236.2,201.6z  M257.5,202.1h32.9c0,0,23.8-4.6,21.8-26.8c0,0,2.1-25.3-27.3-28.3c0,0-22.8-1.5-27.4,20.2V202.1z M236.9,221.9H204 c0,0-23.8,4.6-21.8,26.8c0,0-2.1,25.3,27.3,28.3c0,0,22.8,1.5,27.4-20.2V221.9z M257.5,256.8c4.6,21.8,27.4,20.2,27.4,20.2 c29.4-3,27.3-28.3,27.3-28.3c2-22.3-21.8-26.8-21.8-26.8h-32.9V256.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.3,370.9c11.9,0.3,11.1,9.5,11.1,9.5c0.5,7.5-5.2,9.1-5.2,9.1c7.2,1.6,6.4,9.2,6.4,9.2 c-0.3,10.2-10.8,11-10.8,11H28.8v-38.8H46.3z M36.4,377.5v9.5h8.4c0,0,5.7-0.9,5.2-4.7c0,0,0.5-4.3-5.4-4.7H36.4z M36.4,393.1v10 h9.9c0,0,5.4-0.6,5.1-5c0,0,0-4.7-5.9-5H36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.5,379c11.8,1.1,11,9.1,11,9.1v20.7c-9.9,3.8-18.8,1-18.8,1c-6-1.7-5.7-9.4-5.7-9.4 c0.6-9.7,9.9-8.7,9.9-8.7h7.6v-3.8c-3.5-4.5-14-0.8-14-0.8l-1.3-6.4C69,378.8,75.5,379,75.5,379z M72.8,396.6 c-3.4,0-3.9,4.1-3.9,4.1c0,3,1.9,3.4,1.9,3.4c3.3,1.4,8.7,0,8.7,0v-7.5H72.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.7,379c11.8,1.1,11,9.1,11,9.1v20.7c-9.9,3.8-18.8,1-18.8,1c-6-1.7-5.7-9.4-5.7-9.4 c0.6-9.7,9.9-8.7,9.9-8.7h7.6v-3.8c-3.5-4.5-14-0.8-14-0.8l-1.3-6.4C324.2,378.8,330.7,379,330.7,379z M328,396.6 c-3.4,0-3.9,4.1-3.9,4.1c0,3,1.9,3.4,1.9,3.4c3.3,1.4,8.7,0,8.7,0v-7.5H328z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.1,381.3v28.4h7.2v-22.8c0,0,1-1.4,5.3-1.3c0,0,5.6-0.6,6.6,4.2v19.8h7.1v-21.2c0,0,0.2-8.6-10.5-9.5 C107.8,379,97.6,378.4,92.1,381.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144,386.9l1.3-6.4c0,0-9.1-3.6-17.1,0.7c0,0-6.3,3.1-5.7,13c0,0-1.2,12,8.5,15.4c0,0,7,2.1,14.3-0.8l-0.8-5.8 c0,0-3.8,0.9-6.7,0.8c0,0-8.4-0.4-8.6-9.1c0,0-0.1-9.4,8.5-9C137.7,385.8,141.3,385.4,144,386.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.6,386.9l1.3-6.4c0,0-9.1-3.6-17.1,0.7c0,0-6.3,3.1-5.7,13c0,0-1.2,12,8.5,15.4c0,0,7,2.1,14.3-0.8 l-0.8-5.8c0,0-3.8,0.9-6.7,0.8c0,0-8.4-0.4-8.6-9.1c0,0-0.1-9.4,8.5-9C361.2,385.8,364.8,385.4,367.6,386.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M439.9,386.9l1.3-6.4c0,0-9.1-3.6-17.1,0.7c0,0-6.3,3.1-5.7,13c0,0-1.2,12,8.5,15.4c0,0,7,2.1,14.3-0.8 l-0.8-5.8c0,0-3.8,0.9-6.7,0.8c0,0-8.4-0.4-8.6-9.1c0,0-0.1-9.4,8.5-9C433.6,385.8,437.2,385.4,439.9,386.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.9,385.5c0,0,6.1,0.2,6.5,5.6v7.9c0,0-1.1,4.9-6.5,4.9c0,0-5.2,0.1-6.6-4.5v-9 C155.3,390.4,155.7,385.5,161.9,385.5z M154.6,380.5c-8.3,3.4-6.7,14.8-6.7,14.8c0.2,9.1,2.7,11,2.7,11c2.9,5.2,11.2,4.5,11.2,4.5 c16-0.7,13.6-16.4,13.6-16.4c-0.2-17.8-13.6-15.2-13.6-15.2C157.3,379,154.6,380.5,154.6,380.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M457.6,385.5c0,0,6.1,0.2,6.5,5.6v7.9c0,0-1.1,4.9-6.5,4.9c0,0-5.2,0.1-6.6-4.5v-9 C451,390.4,451.4,385.5,457.6,385.5z M450.3,380.5c-8.3,3.4-6.7,14.8-6.7,14.8c0.2,9.1,2.7,11,2.7,11c2.9,5.2,11.2,4.5,11.2,4.5 c16-0.7,13.6-16.4,13.6-16.4c-0.2-17.8-13.6-15.2-13.6-15.2C453,379,450.3,380.5,450.3,380.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.7,367.7h6.8v40.9c0,0-2.2,1.6-10.4,1.7c0,0-7.2,1-10.9-2.7c0,0-4.8-3.6-4.8-13.4c0,0-1.6-12.2,10.7-14.9 l8.6,0.1V367.7z M204.9,386.3c-4.7,1.5-4.5,7.9-4.5,7.9c-0.4,6,3.4,9,3.4,9c4.1,1.5,8.9,0,8.9,0v-16.9 C209.1,385,204.9,386.3,204.9,386.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.4,404c3.3,0,8.8-2,8.8-2l1.2,6.8c-3.3,1.7-10.5,1.6-10.5,1.6c-16.8,0.5-14.9-15.9-14.9-15.9 c-1.2-16.7,14.5-15.5,14.5-15.5c16.5,1.5,11.5,18.6,11.5,18.6h-18.4C231.8,404.4,239.4,404,239.4,404z M231.2,391.6h12.6 c0,0,0.6-6.2-5.8-6.5C237.9,385.1,232,384.6,231.2,391.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.1,367.7h6.9v32.8c0,0-0.6,4.5,4.4,2.9l1.5,6.2c0,0-5,1.8-8.4,0c0,0-3.6-0.6-4.4-7.3V367.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.4,370.9H303c0,0,12.2-0.2,12.2,12.6c0,0,0.9,12.2-11.1,12.9h-11.4v13.2h-7.2V370.9z M292.5,389.7h11 c4.7-0.9,4.4-6.5,4.4-6.5c0.2-5.8-5.3-5.6-5.3-5.6h-10.1V389.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 379.8,
    className: "st1",
    width: 6.7,
    height: 29.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.1,
    y: 379.8,
    className: "st1",
    width: 6.7,
    height: 29.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "373,376.1 379.1,376.1 384.9,367.8 377.9,367.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.6,370.6c0-2.3-1.9-4.1-4.1-4.1s-4.1,1.9-4.1,4.1c0,2.3,1.9,4.1,4.1,4.1S414.6,372.9,414.6,370.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.9,409.6v-33.5c0,0,0-15.1,18.2-8.9l-1.2,6.2c0,0-7.1-3.1-10.2,1.4l-0.2,5h10.3v6.7h-10.2v23.1H385.9z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBancodelpacifico);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BANCODELPACIFICO.412f307bb8ddaebb6ebe4f8d415e0f8d.svg";